import React from "react";

//material ui
import { Box, Typography, useTheme } from "@mui/material";

//img
import TimeCircle from "../../img/TimeCircle.svg";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    mt: "71px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "repeat(12, 1fr)",
    gap: "0px 32px",
    padding: "0px 64px",
  },
  subContainer: {
    mt: "42px",
    "&:nth-of-type(-n + 4)": {
      gridColumn: "1 / 2",
    },
    "&:nth-of-type(n + 5)": {
      gridColumn: "2 / 3",
    },
    "&:nth-of-type(1)": {
      gridRow: "1 / 4",
    },
    "&:nth-of-type(2)": {
      gridRow: "4 / 7",
    },
    "&:nth-of-type(3)": {
      gridRow: "7 / 10",
    },
    "&:nth-of-type(4)": {
      gridRow: "10 / 13",
    },
    "&:nth-of-type(5)": {
      gridRow: "1 / 4",
    },
    "&:nth-of-type(6)": {
      gridRow: "4 / 7",
    },
    "&:nth-of-type(7)": {
      gridRow: "7 / 10",
    },
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
  flex: { display: "flex" },
  img: { height: "35px", width: "35px" },
  span: { fontWeight: "bold" },
  title: {
    color: theme.palette.blue.fifth,
    fontSize: { md: "22px", xl: "28px" },
    lineHeight: "36px",
    ml: "24px",
    fontFamily: theme.typography.montserrat.regular,
  },
  description: {
    color: theme.palette.white.main,
    fontSize: { md: "18px", xl: "22px" },
    lineHeight: { md: "26px", xl: "32px" },
    maxWidth: { xl: "600px" },
  },
});

const ATypicalDayDesktop = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const componentName = "ATypicalDayDesktop";
  const translation = useTranslation(pathname, componentName);
  const { data, altCircleImg, disclaimer } = translation;

  return (
    <>
      <Box sx={classes.container}>
        {data.map((item, i) => (
          <Box key={item.text} sx={classes.subContainer}>
            <Box sx={{ display: "flex" }}>
              <img src={TimeCircle} alt={altCircleImg} style={classes.img} />
              <Typography sx={classes.title}>
                <span style={classes.span}>{item.text} | </span>
                {item.description}
              </Typography>
            </Box>

            <Box sx={{ mt: "15px", ml: "60px" }}>
              <Typography sx={classes.description}>{item.content}</Typography>
            </Box>
          </Box>
        ))}
      </Box>

      <Typography
        sx={{
          color: theme.palette.white.main,
          fontStyle: "italic",
          fontSize: "20px",
          mt: "69px",
          fontFamily: theme.typography.montserrat.light,
          textAlign: { md: "center", xl: "start" },
          maxWidth: { md: "800px", lg: "900px", xl: "inherit" },
        }}
      >
        {disclaimer}
      </Typography>
    </>
  );
};

export default ATypicalDayDesktop;
